// extracted by mini-css-extract-plugin
export default {"link":"LinkAction_link__-uJ3D","label":"LinkAction_label__3tEFj"};